import React, { useState, useEffect } from "react";
import Logo from "../../assets/image/logo-image.png";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { message } from "antd";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { storage } from "../../utils/auth";

function FlightServicelogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [loginBackground, setLoginBackground] = useState("");
  const [loginBackgroundColor, setLoginBackgroundColor] = useState("");
  const [brandingLogo, setBrandingLogo] = useState("");

  const navigate = useNavigate();

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleChange();
    }
  };
  useEffect(() => {
    if (storage.get("token")) {
      navigate(`/flight-service/flight-details`);
    }
    axios
      .get(`${process.env.REACT_APP_API_END_POINT}/get-registration-visibility`)
      .then((res) => {
        if (res.data.data) {
          if (res.data.data.login_background) { setLoginBackground(res.data.data.login_background); }
          if (res.data.data.login_background_color) { setLoginBackgroundColor(res.data.data.login_background_color); }
          if (res.data.data.branding_logo) {
            setBrandingLogo(res.data.data.branding_logo);
          }
        }
      })
      .catch((err) => console.log(err));
  }, []);

  const loginBGStyle = loginBackground
    ? {
      backgroundImage: `url("${process.env.REACT_APP_IMAGE_URL}/branding/${loginBackground}")`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundSize: "contain",
      backgroundColor: loginBackgroundColor || "#ee272a",
    }
    : {};

  const logoSrc = brandingLogo
    ? `${process.env.REACT_APP_IMAGE_URL}/branding/${brandingLogo}`
    : Logo;

  const handleChange = () => {
    setIsLoading(true);
    if (!email) {
      message.error("Enter username or email");
      setIsLoading(false);

      return;
    }
    if (!password) {
      message.error("Enter password");
      setIsLoading(false);

      return;
    } else {
      axios
        .post(`${process.env.REACT_APP_API_END_POINT}/login`, {
          email,
          password,
        })
        .then((response) => {
          storage.set(
            "permission",
            JSON.stringify(response.data.category.permissions)
          );
          storage.set("token", response.data.token);
          storage.set("user_id", response.data.category._id);
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          console.log(error);
        })
        .finally(() => {
          let data = storage.get("permission");
          data = JSON.parse(data);
          console.log("data", data);
          let nameArray = [];
          axios
            .post(
              `${process.env.REACT_APP_API_END_POINT}/get-permission-name`,
              {
                permission: data,
              }
            )
            .then((res) => {
              console.log(".data.data", res.data.data);
              nameArray = res.data.data;

              if (nameArray.includes("flight_details")) {
                console.log("running inside if");
                navigate("/flight-service/flight-details");
              } else {
                message.error("Not Authorised");
              }
            });
        });
    }
  };

  return (
    <>
      <div className="kcebg" style={loginBGStyle}>
        <div className="exhibitorlogin">
          <div className="exhibitorloginbody">
            {/* <div className="fw-semi-bold fs-3">Welcome to Flight Service</div> */}
            <Form className="my-4" onSubmit={(e) => e.preventDefault()}>
              <Form.Control
                type="username"
                id="inputUsename"
                aria-describedby="passwordHelpBlock"
                placeholder="Username"
                className="my-4"
                required
                onChange={(e) => setEmail(e.target.value)}
                onKeyDown={handleKeyDown}
              />

              <Form.Control
                type="password"
                id="inputPassword5"
                aria-describedby="passwordHelpBlock"
                placeholder="Password"
                required
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={handleKeyDown}
              />

              <Button className="my-4 btn-block" onClick={handleChange}>
                {isLoading ? <Spinner animation="border" size="sm" /> : "Login"}
              </Button>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
}

export default FlightServicelogin;
